import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_OT0023Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import { fnGetValueByKey } from "../../../helpers/functions";
import withRouter from "../../../components/Common/withRouter";
import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

const PROC_NAME = "SRM_Agendamento_Gerenciador_Limite_Obter_Lista_Pop_Up";

const DF_OT0023 = ({ isOpen, toggle, idParceiro }) => {
  console.log("🤖 %cTransação [DF_OT0023]", "color:green");

  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.profile,
  }));

  const user = useSelector((state) => state.login.user);
  const csrfToken = useGetCsrfToken();

  const [isLoading, setisLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const fetchDetails = async (id) => {
    if (!id) {
      return;
    }

    setisLoading(true);
    setError(null);
    try {
      const procParams = {
        1: parseInt(id),
      };

      const res = await BizinBackend.executeProcedure(
        procParams,
        PROC_NAME,
        csrfToken,
        user?.access_token,
      );

      const d = res?.resultset_1 || res;

      setData(Array.isArray(d) ? d : d ? [d] : []);
    } catch (err) {
      setError("Ocorreu um erro ao carregar as informações do pop-up.");
      setData([]);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && idParceiro) {
      fetchDetails(idParceiro);
    }
  }, [isOpen, idParceiro]);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        size="xl"
        className="modal-dialog-centered"
        style={{ maxWidth: "1000px" }}
      >
        <DF_OT0023Context.Provider
          value={{
            isLoading,
            userProfile,
            setisLoading,
            data,
            setData,
            error,
            fnGetValueByKey,
            toggle,
          }}
        >
          <div className="p-3 bg-white rounded shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <GridHeader />
              <button
                type="button"
                className="btn border-0 p-0"
                onClick={toggle}
                aria-label="Close"
              >
                <i className="fas fa-times font-size-24 text-gray-secundary"></i>
              </button>
            </div>

            <ModalBody className="px-0 py-2">
              <GridBody />
            </ModalBody>
          </div>
        </DF_OT0023Context.Provider>
      </Modal>
    </React.Fragment>
  );
};

DF_OT0023.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  idParceiro: PropTypes.any,
};

export default withRouter(DF_OT0023);